var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 position-relative" },
    [
      _c("UiInput", {
        attrs: { placeholder: _vm.placeholder },
        on: { input: _vm.onInput },
        model: {
          value: _vm.currentValue,
          callback: function ($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isValid,
              expression: "isValid",
            },
          ],
          staticClass: "validation-check text-success",
        },
        [
          _c("i", {
            staticClass: "fa fa-check fa-lg",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }